import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.23503 11.7047C4.9339 11.9892 4.92033 12.4638 5.20474 12.765C5.48915 13.0661 5.96383 13.0797 6.26497 12.7953L10.765 8.54526C10.915 8.40358 11 8.20635 11 8C11 7.79366 10.915 7.59643 10.765 7.45474L6.26497 3.20474C5.96383 2.92033 5.48915 2.9339 5.20474 3.23503C4.92033 3.53617 4.9339 4.01085 5.23503 4.29526L9.1577 8L5.23503 11.7047Z",
		fill: ""
	})
});
export default SvgChevronRight;
